<template>
  <div
    :class="
      twMerge(
        'mb-3.5 overflow-hidden rounded-xl border  lg:rounded-2xl',
        useDarkMode ? 'bg-blue-darkest border-blue' : 'border-blue-light bg-white',
      )
    "
  >
    <button class="flex w-full items-center justify-between p-4 lg:px-6 lg:py-5" @click="openClose">
      <span
        :class="
          twMerge(
            'w-full text-left font-serif text-2xl leading-[1.136] lg:text-3xl lg:font-bold lg:leading-snug',
            useDarkMode ? 'text-white' : 'text-black',
          )
        "
      >
        <slot name="header"></slot>
      </span>
      <PlusBox
        v-if="!isShow"
        :fill="useDarkMode ? '#00B4D2' : ''"
        class="ml-3 h-4 w-4 shrink-0 lg:h-6 lg:w-6"
      />
      <MinusBox v-else class="ml-3 h-4 w-4 shrink-0 lg:h-6 lg:w-6" />
    </button>
    <div
      class="wrapper grid grid-flow-col border-t"
      :class="[
        isShow && 'is-open',
        useDarkMode ? 'bg-blue-darkest border-blue' : 'border-grey-light bg-white',
      ]"
    >
      <div :class="twMerge('inner overflow-hidden', useDarkMode ? 'bg-blue-darkest' : '')">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, inject, ref } from 'vue'
import PlusBox from '../atoms/Icons/PlusBox.vue'
import MinusBox from '../atoms/Icons/MinusBox.vue'
import { twMerge } from 'tailwind-merge'

const props = defineProps({
  open: { type: Boolean, default: false },
})

const isShow = ref(props.open)

const openClose = () => {
  isShow.value = !isShow.value
}

const settings = inject<string[]>('settings', [])
const useDarkMode = computed(() => settings?.includes('dark_theme') ?? false)
</script>

<style scoped>
.wrapper {
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.5s ease-out;
}

.wrapper.is-open {
  grid-template-rows: 1fr;
}
</style>
